import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Archive, X, Warning } from "@phosphor-icons/react";

const todayIso = () => new Date().toISOString().slice(0, 10);

export default function ArchiveOldModal({ onClose, onArchived }) {
  const [cutoff, setCutoff] = useState(todayIso());
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [confirming, setConfirming] = useState(false);
  const [error, setError] = useState("");

  const runPreview = async () => {
    if (!cutoff) return;
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/orders/archive-old", { cutoff_date: cutoff, dry_run: true });
      setPreview(data.would_archive);
    } catch (e) {
      setError(e?.response?.data?.detail || "Erro ao consultar prévia");
      setPreview(null);
    } finally {
      setLoading(false);
    }
  };

  // Preview automático ao mudar a data
  useEffect(() => {
    const t = setTimeout(runPreview, 300);
    return () => clearTimeout(t);
  }, [cutoff]); // eslint-disable-line react-hooks/exhaustive-deps

  const confirmArchive = async () => {
    if (!preview || preview === 0) return;
    setConfirming(true);
    setError("");
    try {
      const { data } = await api.post("/orders/archive-old", { cutoff_date: cutoff });
      onArchived(data.archived);
    } catch (e) {
      setError(e?.response?.data?.detail || "Erro ao arquivar");
      setConfirming(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-6" onClick={onClose}>
      <div className="glass max-w-lg w-full p-8" onClick={(e) => e.stopPropagation()} data-testid="archive-old-modal">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <Archive size={22} weight="bold" />
            <div className="overline">LIMPEZA EM MASSA</div>
          </div>
          <button onClick={onClose}><X size={22} /></button>
        </div>
        <h2 className="font-head text-2xl font-black mb-2">Arquivar pedidos antigos</h2>
        <p className="text-sm text-zinc-600 mb-6">
          Marca como <strong>arquivados</strong> todos os pedidos com <strong>Data Limite anterior</strong> à data escolhida abaixo, que <strong>ainda não foram enviados</strong>. Pedidos arquivados <strong>somem</strong> das listagens, do Kanban e do contador de atrasos, mas <strong>NÃO são deletados</strong>.
        </p>
        <div className="space-y-4">
          <div>
            <label className="label">Arquivar pedidos com Data Limite anterior a:</label>
            <input type="date" className="input font-mono" value={cutoff} onChange={(e) => setCutoff(e.target.value)} data-testid="archive-cutoff" />
          </div>
          {loading ? (
            <div className="text-sm text-zinc-400 border border-zinc-200 px-3 py-2">Calculando prévia…</div>
          ) : preview !== null && (
            <div className={`border-2 ${preview === 0 ? "border-zinc-300 bg-zinc-50" : "border-[#FFC000] bg-yellow-50"} px-4 py-3`} data-testid="archive-preview">
              <div className="flex items-center gap-2">
                {preview > 0 && <Warning size={18} weight="fill" className="text-[#B37400]" />}
                <div>
                  <div className="font-mono text-2xl font-bold">{preview}</div>
                  <div className="text-xs uppercase tracking-widest text-zinc-600">pedido{preview === 1 ? "" : "s"} {preview > 0 ? "será(ão) arquivado(s)" : "encontrado(s)"}</div>
                </div>
              </div>
            </div>
          )}
          {error && <div className="border border-[#E60000] bg-red-50 text-[#E60000] text-sm px-3 py-2" data-testid="archive-error">{error}</div>}
        </div>
        <div className="flex gap-3 pt-6">
          <button type="button" className="btn btn-ghost flex-1" onClick={onClose}>Cancelar</button>
          <button
            type="button"
            className="btn flex-1"
            style={{ background: "#B37400", borderColor: "#B37400", color: "#fff" }}
            onClick={confirmArchive}
            disabled={confirming || loading || !preview}
            data-testid="archive-confirm"
          >
            {confirming ? "Arquivando..." : `Arquivar ${preview || 0} pedidos`}
          </button>
        </div>
      </div>
    </div>
  );
}
